import React from 'react';
import {
  DialogProps,
  DialogTriggerProps,
  Dialog as RACDialog,
  DialogTrigger as RACDialogTrigger
} from 'react-aria-components';

import './dialog.global.scss';

export function Dialog(props: DialogProps) {
  return <RACDialog {...props} />;
}

export function DialogTrigger(props: DialogTriggerProps) {
  return <RACDialogTrigger {...props} />;
}
